// 監視対象の要素（ここでは body 要素）を選択
const targetNode = document.body;

// オブザーバの設定
const config = { childList: true, subtree: true };

// コールバック関数を受け取るオブザーバのインスタンスを作成
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // すべてのIDが "BIS_trigger" である要素を取得
    var triggers = document.querySelectorAll('#BIS_trigger');
    // 各ボタンに対して処理
    triggers.forEach(function(trigger) {
      // クラス名をチェックして非表示にするものを決定
      if(trigger.classList.contains('ProductForm__AddToCart')) {
        // trigger.style.display = 'none';
        trigger.classList.add('display-none');
      }
    });
  });
});

// オブザーバを起動
observer.observe(targetNode, config);